<script>
  export let filled = false;
</script>

<div class="point" class:filled={filled === true}></div>

<style>
  .point {
    background-color: var(--pax-smoke);
    height: 1rem;
    width: 1rem;
    border-radius: 50%;
  }

  .filled {
    background-color: #61a68c;
  }
</style>
